/* eslint-disable no-param-reassign */
/* eslint-disable unicorn/no-array-reduce */
/* eslint-disable no-return-assign */
import React from 'react'
import useGlobalStore from '@/store/useGlobalStore'
import { Badge } from '@/components/_ui/Badge'

export const CartBadge = () => {
  const {
    cart: { otp, subscribe },
  } = useGlobalStore()

  const totalOtps = otp.reduce((_, item, q) => (q += item.qty), 0)
  const totalSubscriptions = subscribe.reduce(
    (_, item, q) => (q += item.qty),
    0,
  )

  const totalItemsInCart = totalOtps + totalSubscriptions

  return totalItemsInCart > 0 ? (
    <Badge className="absolute mb-[34px] ml-[30px] px-2">
      {totalItemsInCart}
    </Badge>
  ) : (
    <></>
  )
}
